import React from "react";
import Table from "react-bootstrap/Table";
import { customName, getColorFromId } from "../../helpers/commonHelpers";

const AttendeeRsvpTable = (props) => {
  let trData = [];
  for (const [key, value] of Object.entries(props.rsvpObject)) {
    trData.push(
      <tbody>
        <tr>
          <th colspan="3">
            {key.charAt(0).toUpperCase() + key.toLowerCase().slice(1)}
          </th>
        </tr>
        <tr>
          <td>
            {value.length &&
              value.map((attendee, index) => {
                return (
                  <div className="attendee-content" key={index}>
                    <div className="" key={index}>
                      <div
                        className="attendee-list attendee-list-circle"
                        style={{
                          backgroundColor: attendee?.profilePicture
                            ? undefined
                            : getColorFromId(attendee._id),
                        }}
                      >
                        {attendee?.profilePicture ? (
                          <img
                            src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                            alt=""
                            className="attendee-profile-picture icon-image attendee-list-circle-img"
                            style={{}}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.style.display = "none";

                              e.target.parentElement.style.backgroundColor =
                                getColorFromId(attendee._id);
                              e.target.parentElement.innerText = customName(
                                attendee.name
                              );
                            }}
                          />
                        ) : (
                          customName(attendee.name)
                        )}
                      </div>
                    </div>

                    <div className="action-cmnt-text">
                      <p className="detail-name word-break">{attendee.name}</p>
                      <p className="name-undertext  comment-text">
                        {attendee.email}
                      </p>
                    </div>
                  </div>
                );
              })}
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <>
      {trData.length === 0 ? (
        <p>No RSVP confirmation recieved.</p>
      ) : (
        <Table striped bordered>
          {trData}
        </Table>
      )}
    </>
  );
};

export default AttendeeRsvpTable;
